import axiosInstance from './axiosInstance';

export type UrinationPatternFileFormat = 'pdf' | 'xlsx';

export interface ExportUrinationPatternParams {
  carehomeId: string;
  fileFormat: UrinationPatternFileFormat;
  residentIds: string[];
  language: string;
}

export interface ExportRepositioningHistoryParams {
  carehomeId: string;
  residentIds: string[];
  startDateIso: string;
  endDateIso: string;
  language: string;
}

export interface ExportUrineHistoryParams {
  carehomeId: string;
  residentIds: string[];
  startDateIso: string;
  endDateIso: string;
  language: string;
}

class StatsService {
  private static instance: StatsService;

  private constructor() {}

  public static getInstance(): StatsService {
    if (!StatsService.instance) {
      StatsService.instance = new StatsService();
    }
    return StatsService.instance;
  }

  public async exportUrinationPattern(
    params: ExportUrinationPatternParams
  ): Promise<void> {
    await axiosInstance.get('/stats/urination_pattern', {
      params: {
        carehome_id: params.carehomeId,
        file_format: params.fileFormat,
        resident_ids: params.residentIds.join(','),
        language: params.language,
      },
    });
  }

  public async exportRepositioningHistory(
    params: ExportRepositioningHistoryParams
  ): Promise<void> {
    await axiosInstance.get('/stats/repositioning_history', {
      params: {
        carehome_id: params.carehomeId,
        resident_ids: params.residentIds.join(','),
        start_date: params.startDateIso,
        end_date: params.endDateIso,
        language: params.language,
      },
    });
  }

  public async exportUrineHistory(
    params: ExportUrineHistoryParams
  ): Promise<void> {
    await axiosInstance.get('/stats/urine_history', {
      params: {
        carehome_id: params.carehomeId,
        resident_ids: params.residentIds.join(','),
        start_date: params.startDateIso,
        end_date: params.endDateIso,
        language: params.language,
      },
    });
  }
}

export default StatsService.getInstance();
